export default __webpack_public_path__ + "static/media/ems_grid.419bbece.svg";